import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { LineBreaksPipe } from '@qwyk/ui-standalone';

import { components } from './components';
import * as fromCustomFields from './+state/custom-fields.reducer';
import { CustomFieldsFacade } from './+state/custom-fields.facade';
import { CustomFieldsEffects } from './+state/custom-fields.effects';
import { CustomFieldValuePipe } from './pipes/custom-field-value.pipe';

@NgModule({
    imports: [
        CommonModule,
        LineBreaksPipe,
        StoreModule.forFeature(
            fromCustomFields.CUSTOMFIELDS_FEATURE_KEY,
            fromCustomFields.reducer
        ),
        EffectsModule.forFeature([CustomFieldsEffects]),
    ],
    declarations: [...components, CustomFieldValuePipe],
    exports: [...components],
    providers: [CustomFieldsFacade],
})
export class PortalsCustomFieldsModule {}
